<template>
  <section :id="id" :class="containerClasses" class="flex rounded">
    <button
      v-for="option in optionsClean"
      :id="`${id}-${option.value}`"
      :key="`${id}-${option.value}`"
      class="grow text-left first:rounded-l-sm last:rounded-r-sm"
      :class="option.classes"
      @click="$emit('update:modelValue', option.value)"
      :style="sameWidthOptions ? { width: `${optionWidth}%` } : undefined"
    >
      {{ option.label }}
    </button>
  </section>
</template>
<script lang="ts">
import { HTMLAttributes, PropType, defineComponent } from 'vue'

type ButtonGroupVariant = 'button' | 'text' | 'large'
interface OptionClean {
  classes: HTMLAttributes['class']
  value: string | number
  label: string
}

export default defineComponent({
  name: 'ButtonGroup',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    id: { type: String, required: true },
    modelValue: { required: false },
    options: { type: Array as PropType<any[]>, required: true },
    itemText: { type: String, required: false },
    itemValue: { type: String, required: false },
    variant: {
      type: String as PropType<ButtonGroupVariant>,
      required: false,
      default: 'button',
    },
    sameWidthOptions: { type: Boolean, default: true },
  },
  emits: {
    'update:modelValue'(evt: any) {
      return !!evt
    },
  },
  computed: {
    optionWidth(): number {
      return 100 / this.options.length
    },
    containerClasses(): HTMLAttributes['class'] {
      switch (this.variant) {
        case 'button':
          return 'p-[1px] bg-surface-inverse text-base'
        case 'text':
          return 'text-xs border border-linear-strong'
        case 'large':
          return 'text-base border border-linear-strong'
        default:
          return ''
      }
    },
    optionsClean(): OptionClean[] {
      return this.options.map(opt => {
        const value = this.itemValue ? opt[this.itemValue] : opt
        const isSelected = value === this.modelValue
        let classes: HTMLAttributes['class']
        switch (this.variant) {
          case 'button':
            classes = [
              'px-4 py-2 font-heading',
              isSelected
                ? 'bg-surface-inverse text-fg-inverse'
                : 'bg-surface-primary text-fg-primary',
            ]
            break
          case 'text':
            classes = [
              'px-2 py-1 font-body',
              isSelected ? 'text-fg-primary font-semibold' : 'text-fg-link-primary',
            ]
            break
          case 'large':
            classes = [
              'px-4 py-2 font-heading',
              isSelected ? 'text-fg-primary font-semibold' : 'text-fg-link-primary',
            ]
            break
        }

        return {
          classes,
          value,
          label: this.itemText ? opt[this.itemText] : opt,
        }
      })
    },
  },
})
</script>
